import { useRef, useEffect } from 'react';
import YouTube from 'react-youtube';
import ReactPixel from 'react-facebook-pixel';
import './styles/VideoFrame.css';

function VideoFrame() {
  const playerRef = useRef(null);
  const progressFlags = useRef({
    watched30: false,
    watched50: false,
    watched75: false,
    watched100: false,
  });
  const progressTicker = useRef(null);

  const handleVideoPlay = () => {
    ReactPixel.trackCustom('VideoPlayed', {
      platform: 'YouTube',
      video_title: 'Talabarte - Absorvedor de Energia',
      section: 'Hero',
    });

    // inicia o intervalo para monitorar progresso
    if (progressTicker.current) clearInterval(progressTicker.current);
    progressTicker.current = setInterval(checkProgress, 1000);
  };

  const handleVideoPauseOrEnd = () => {
    if (progressTicker.current) {
      clearInterval(progressTicker.current);
      progressTicker.current = null;
    }
  };

  const getPlayedPercent = () => {
    const player = playerRef.current;
    if (!player) return 0;
    const duration = player.getDuration();
    const current = player.getCurrentTime();
    if (!duration || duration === 0) return 0;
    return (current / duration) * 100;
  };

  const maybeTrackPercent = (percent) => {
    if (percent >= 30 && !progressFlags.current.watched30) {
      ReactPixel.trackCustom('VideoWatched30', {
        video_title: 'Talabarte - Absorvedor de Energia',
        section: 'Hero',
      });
      progressFlags.current.watched30 = true;
    }

    if (percent >= 50 && !progressFlags.current.watched50) {
      ReactPixel.trackCustom('VideoWatched50', {
        video_title: 'Talabarte - Absorvedor de Energia',
        section: 'Hero',
      });
      progressFlags.current.watched50 = true;
    }

    if (percent >= 75 && !progressFlags.current.watched75) {
      ReactPixel.trackCustom('VideoWatched75', {
        video_title: 'Talabarte - Absorvedor de Energia',
        section: 'Hero',
      });
      progressFlags.current.watched75 = true;
    }

    if (percent >= 95 && !progressFlags.current.watched100) {
      ReactPixel.trackCustom('VideoWatched100', {
        video_title: 'Talabarte - Absorvedor de Energia',
        section: 'Hero',
      });
      progressFlags.current.watched100 = true;
    }
  };

  const checkProgress = () => {
    const played = getPlayedPercent();
    maybeTrackPercent(played);
  };

  const handleStateChange = (event) => {
    const player = event.target;
    const state = event.data;
    playerRef.current = player;

    if (state === 1) handleVideoPlay(); // playing
    if (state === 2 || state === 0) handleVideoPauseOrEnd(); // paused or ended
  };

  const handleClickVideoBTN = (e) => {
    e.preventDefault(); // evita comportamento padrão do botão/link

    // 🔹 Envia evento para o Pixel
    ReactPixel.trackCustom('Lead', {
            action: 'Clique QUERO SABER MAIS',
            origem: 'Seção Video',
        });

        // 🔹 Faz scroll suave até a seção com id="value"
        const target = document.getElementById('value');
        if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

  useEffect(() => {
    return () => {
      if (progressTicker.current) clearInterval(progressTicker.current);
    };
  }, []);

  const opts = {
    width: '100%',
    height: '100%',
    playerVars: {
      rel: 0,
      modestbranding: 1,
      playsinline: 1,
      origin: window.location.origin,
    },
  };

  return (
    <>
      <div className="video-container">
        <h3>Você sabe exatamente QUANDO e COMO o absorvedor de energia do seu talabarte entra em ação?</h3>

        <YouTube
          videoId="WAxUQAMKYpU"
          opts={opts}
          onStateChange={handleStateChange}
          className="iframe"
        />

          <button className="fade-in-up" onClick={handleClickVideoBTN}>
            Quero saber mais
          </button>
      </div>
    </>
  );
}

export default VideoFrame;